import React, { useState } from "react";

/**
 * More reliable than /embed/videoseries alone.
 * If you know the first video ID, pass it as firstVideoId and we'll embed that
 * with ?list=PLAYLIST_ID (best). If not, we’ll use videoseries and still show a
 * clean fallback if the player errors (e.g., Error 153).
 */
export default function YouTubeEmbed({
                                         playlistId,
                                         firstVideoId, // e.g., "dQw4w9WgXcQ" (optional but recommended)
                                         title = "NYX NoCode Demo",
                                     }) {
    const [failed, setFailed] = useState(false);

    const src = firstVideoId
        ? `https://www.youtube-nocookie.com/embed/${firstVideoId}?list=${playlistId}&rel=0&modestbranding=1&playsinline=1`
        : `https://www.youtube-nocookie.com/embed/videoseries?list=${playlistId}&rel=0&modestbranding=1&playsinline=1`;

    if (failed) {
        return (
            <div className="yt-fallback">
                <p>Having trouble loading the video player.</p>
                <a
                    href={`https://www.youtube.com/playlist?list=${playlistId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Watch this playlist on YouTube
                </a>
            </div>
        );
    }

    return (
        <div className="video-wrapper">
            <iframe
                title={title}
                src={src}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                onError={() => setFailed(true)}
            />
            <noscript>
                <p>
                    JavaScript is disabled.{" "}
                    <a
                        href={`https://www.youtube.com/playlist?list=${playlistId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Watch the playlist on YouTube
                    </a>
                    .
                </p>
            </noscript>
        </div>
    );
}

